/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  dummy: 'dummy_1379ffdb',
};

export = styles;

loadStyles([{"rawString":".dummy_1379ffdb{background:#00f}"}]);
/* tslint:enable */